import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { isLakehouseContext } from '../../utils/restaurantContext';

const HeroSection = () => {
    const { user } = useContext(AuthContext);
    const isRestaurantTwoUser = isLakehouseContext(user);
    const isRestaurantOneUser = Boolean(user) && Number.parseInt(user?.restaurant_id, 10) === 1;
    const showVisitLakehouse = !isRestaurantTwoUser && !isRestaurantOneUser;
    const heroBackgroundImage = isRestaurantTwoUser
            ? '/images/casagatchalianlakehouse_mainbg.jpg'
            : '/images/restaurant-bg.png';
    const heroAriaLabel = isRestaurantTwoUser
            ? 'Casa Gatchalian Lakehouse exterior'
            : 'Casa Gatchalian bar interior with hanging lights';

    const handleScroll = () => {
      const el = document.getElementById('explore');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    };
    return (
    <section className="relative h-screen min-h-[500px] sm:min-h-[600px]">
            {/* Use inline style so CRA serves public image correctly at /images/... */}
            <div
                className="hero absolute inset-0 bg-cover bg-center bg-no-repeat"
                style={{ backgroundImage: `url(${heroBackgroundImage})` }}
                role="img"
                aria-label={heroAriaLabel}
            >
                <div className="hero-overlay absolute inset-0"></div>
                <div className="absolute inset-0 flex flex-col justify-center text-left px-4 sm:px-8 md:px-12 lg:pl-24 max-w-3xl">
                    <h1
                        className={`font-playfair text-white leading-[0.92] mb-4 sm:mb-6 ${
                            isRestaurantTwoUser
                                ? 'text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-[4.25rem] tracking-[0.05em] sm:tracking-[0.07em] md:tracking-[0.09em]'
                                : 'text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-[6rem] tracking-[0.08em] sm:tracking-[0.1em] md:tracking-[0.15em]'
                        }`}
                    >
                        <span className="block">CASA</span>
                        {isRestaurantTwoUser ? (
                            <>
                                <span className="block">GATCHALIAN</span>
                                <span className="block text-[0.72em] tracking-[0.12em]">LAKEHOUSE</span>
                            </>
                        ) : (
                            <span className="block">GATCHALIAN</span>
                        )}
                    </h1>
                    <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
                        <button onClick={handleScroll} className="relative mt-2 sm:mt-4 inline-block bg-[#6b3fa0]/0 hover:bg-[#6b3fa0]/70 transition-colors px-5 sm:px-8 md:px-10 py-2.5 sm:py-3 border border-transparent font-montserrat tracking-widest text-[9px] sm:text-[10px] md:text-xs text-white after:content-[''] after:absolute after:inset-0 after:border after:border-white after:pointer-events-none active:scale-95">
                            EXPERIENCE NOW!
                        </button>

                        {showVisitLakehouse && (
                            <Link
                                to="/lakehouse"
                                className="relative mt-2 sm:mt-4 inline-block bg-transparent hover:bg-white/15 transition-colors px-5 sm:px-8 md:px-10 py-2.5 sm:py-3 border border-white/70 font-montserrat tracking-widest text-[9px] sm:text-[10px] md:text-xs text-white text-center"
                            >
                                VISIT LAKEHOUSE
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};


export default HeroSection;